// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2A6MG","containerItemsCenter":"Skeleton_containerItemsCenter__cdmE6"};